import ElBackTop from './src/back-top';

/* istanbul ignore next */
ElBackTop.install = function(Vue) {
  Vue.component(ElBackTop.name, ElBackTop);
};

export default ElBackTop;



// WEBPACK FOOTER //
// ./packages/back-top/index.js